// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"MoreSmart_TheComp__fAQYq"};